import { getState } from 'utils/getStore';
import * as subscriptionsSelectors from 'data/subscriptions/subscriptionsSelectors';
import * as profileSelectors from 'data/profile/selectors';
import * as authSelectors from 'utils/auth/selectors';
import { getLogger } from 'utils/logger';
import { Config, BUILD_TYPE } from 'utils/webappConfig';
import * as entitlementsSelectors from 'data/entitlements/entitlementsSelectors';
import UAParser from 'ua-parser-js';

const userAgentParser = new UAParser();
const log = getLogger('utils/tracker');

class Tracker {

  // list of all tracker events
  events = {
    accountListArrow: 'accountListArrow',
    accountNameSave: 'accountNameSave',
    active: 'active',
    crash: 'crash',
    exception: 'exception',
    assert: 'assert',
    fiErrorDetailsView: 'fiErrorDetailsView',
    fiLoginFixItFlowStart: 'fiLoginFixItFlowStart',
    fiLoginFixItFlowCancel: 'fiLoginFixItFlowCancel',
    fiLoginNameSave: 'fiLoginNameSave',
    txnManualMatch: 'txnManualMatch',
    txnDelete: 'txnDelete',
    txnSave: 'txnSave',
    txnPrefs: 'txnPrefs',
    txnEditDetails: 'txnEditDetails',
    accountBalanceChange: 'accountBalanceChange',
    accountBalanceMismatch: 'accountBalanceMismatch', //  { datasetId: xxx, accountId: xxx, delta: ### }
    txnRegActivity: 'txnRegActivity',
    txnReviewMany: 'txnReviewMany',
    reconcileAnAccount: 'reconcileAnAccount',   // { method: 'Paper Statement' or 'Online Balance', status: 'Started' or 'Completed'

    spendingDrillDown: 'spendingDrillDown',
    spendingDateRange: 'spendingDateRange',
    spendingBreadcrumb: 'spendingBreadcrumb',
    spendingChartView: 'spendingChartView',
    barSelected: 'barSelected',
    payeeSelected: 'payeeSelected',

    editBudget: 'editBudget',
    budgetView: 'budgetView',
    budgetChange: 'budgetChange',
    connectivity: 'connectivity',
    experiment: 'experiment',

    myAccount: 'myAccount',
    datasetChange: 'datasetChange',
    datasetNameSave: 'datasetNameSave',

    addFIStart: 'addFIStart',
    addFISelect: 'addFISelect',
    addFIAuthenticated: 'addFIAuthenticated',
    addFIComplete: 'addFIComplete',

    addFICancel: 'addFICancel',
    addFIError: 'addFIError',

    watchlistCreate: 'watchlistCreate',
    watchlistEdit: 'watchlistEdit',
    watchlistDelete: 'watchlistDelete',
    watchlistDetailsView: 'watchlistDetailsView',

    nps: 'nps',

    categoryCreate: 'categoryCreate',
    categoryEdit: 'categoryEdit',
    categoryDelete: 'categoryDelete',

    tagCreate: 'tagCreate',
    tagEdit: 'tagEdit',
    tagDelete: 'tagDelete',

    // getting started funnels and flows
    pageView: 'pageView',
    signUp: 'signUp',
    signIn: 'signIn',
    authWidgetRedirect: 'authWidgetRedirect',

    // simplifi set-up flow
    datasetCreated: 'datasetCreated',
    firstName: 'firstName',
    lastName: 'lastName',
    zipCode: 'zipCode',
    addedNewIncome: 'addedNewIncome',
    addedNewBill: 'addedNewBill',
    confirmedIncome: 'confirmedIncome',
    confirmedBill: 'confirmedBill',
    removedIncome: 'removedIncome',
    removedBill: 'removedBill',
    editModel: 'editModel',
    fisAdded: 'fisAdded',
    completeGettingStarted: 'completeGettingStarted',

    showIntercom: 'showIntercom',

    survey: 'survey', // TODO: temporary hack - we should use MCP instead - remove it

    // Saving Goals
    createGoal: 'createGoal',
    editGoal: 'editGoal',
    takeFrom: 'takeFrom',
    addTo: 'addTo',

    // Transition Page events
    transitionPageStart: 'transitionPageStart',
    transitionStartChoice: 'transitionStartChoice',
    transitionDownloadPlatform: 'transitionDownloadPlatform',

    // Webfirst wizard
    wizardWFClose: 'wizardWFClose',
    wizardTopMenuAccounts: 'wizardTopMenuAccounts',
    wizardTopMenuBillscout: 'wizardTopMenuBillscout',
    wizardTopMenuBudgets: 'wizardTopMenuBudgets',

    // Webfirst Billscout
    editedIncome: 'editedIncome',
    skipIncome: 'skipIncome',
    editedBill: 'editedBill',
    skipBill: 'skipBill',
    findFromTransaction: 'findFromTransaction',
    addManually: 'addManually',
    dashboardBillscout: 'dashboardBillscout',
    wizardBillscout: 'wizardBillscout',

    // Webfirst Budget
    openBudgetSuggestion: 'openBudgetSuggestion',
    addedNewBudgetCategory: 'addedNewBudgetCategory',
    editedBudgetAmount: 'editedBudgetAmount',
    removedBudgetCategory: 'removedBudgetCategory',
    dashboardAddBudget: 'dashboardAddBudget',
    wizardAddBudget: 'wizardAddBudget',
    skipBudgetFlow: 'skipBudgetFlow',
    createdBudget: 'createdBudget',
    editedBudget: 'editedBudget',

    // Webfirst accounts
    dashboardAddAccount: 'dashboardAddAccount',
    wizardAddAccount: 'wizardAddAccount',

    // app init
    init: 'init',
    persistLoadStart: 'persistLoadStart',
    persistLoadComplete: 'persistLoadComplete',

    // mcp
    memberCommunicationDisplayMessage: 'MemberCommunication:displayMessage',
    memberCommunicationDismissMessage: 'MemberCommunication:dismissMessage',

    // Monthly Summary Rating
    monthlySummary: 'monthlySummary', // { rating: int, feedback: string }


    // ^^^ add your new event above
  };

  dateLastActiveTracked;

  constructor() {
    this.dateLastActiveTracked = new Date(0);

    /* eslint-disable */
    (function (e, a) {
      if (!a.__SV) {
        var b = window;
        try {
          var c,
            l,
            i,
            j = b.location,
            g = j.hash;
          c = function (a, b) {
            return (l = a.match(RegExp(b + '=([^&]*)'))) ? l[1] : null;
          };
          g && c(g, 'state') && (i = JSON.parse(decodeURIComponent(c(g, 'state'))), 'mpeditor' === i.action && (b.sessionStorage.setItem('_mpcehash', g), history.replaceState(i.desiredHash || '', e.title, j.pathname + j.search)));
        } catch (m) {
        }
        var k,
          h;
        window.mixpanel = a;
        a._i = [];
        a.init = function (b, c, f) {
          function e(b, a) {
            var c = a.split('.');
            2 == c.length && (b = b[c[0]], a = c[1]);
            b[a] = function () {
              b.push([a].concat(Array.prototype.slice.call(arguments,
                0)));
            };
          }

          var d = a;
          'undefined' !== typeof f ? d = a[f] = [] : f = 'mixpanel';
          d.people = d.people || [];
          d.toString = function (b) {
            var a = 'mixpanel';
            'mixpanel' !== f && (a += '.' + f);
            b || (a += ' (stub)');
            return a;
          };
          d.people.toString = function () {
            return d.toString(1) + '.people (stub)';
          };
          k = 'disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user'.split(' ');
          for (h = 0; h < k.length; h++) e(d, k[h]);
          a._i.push([b, c, f]);
        };
        a.__SV = 1.2;
        b = e.createElement('script');
        b.type = 'text/javascript';
        b.async = !0;
        b.src = 'undefined' !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : 'file:' === e.location.protocol && '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'.match(/^\/\//) ? 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js' : '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
        c = e.getElementsByTagName('script')[0];
        c.parentNode.insertBefore(b, c);
      }
    })(document, window.mixpanel || []);
    /* eslint-enable */

    // prod - aa163a00ce018fca28d192192ed4de8b
    // test - f02e19059c63af74c567d59435e16a1d
    // eslint-disable-next-line camelcase
    const mixpanelToken = (Config?.builds?.[BUILD_TYPE]?.mixpanel_token) || 'f02e19059c63af74c567d59435e16a1d'; // test environment by default
    window.mixpanel.init(mixpanelToken, {
      persistence: 'localStorage',
      persistence_name: 'web_app',
      cross_subdomain_cookie: false,
      cookie_name: 'web_app',
    });
    let clientType;
/////////////////////////////////////////
////////////////////////////////////
/////////////
/////////////////////////////////////////
    clientType = 'Quicken Web App';
/////////////
    const device = window && userAgentParser.getDevice();
    const staticProps = {
      client_type: clientType,
      quicken_year: '2020',
      $app_version_string: process.env.APP_VERSION,
      $app_build_number: process.env.BUILD_NUMBER,
      ...(device && device.type ? undefined : { $device: 'Desktop' }),
    };
    window.mixpanel.register(staticProps);
  }

  defaultProperties() {
    const defaultProperties = {};

    const state = getState();

    const profile = profileSelectors.getProfile(state);
    if (profile && profile.userId) {
      defaultProperties.qcs_id = profile.userId;
    } else {
      defaultProperties.qcs_id = 'unknown';
    }

    const authSession = authSelectors.getAuthSession(state);
    defaultProperties.dataset_id = authSession && authSession.datasetId;
    defaultProperties.dataset_platform = authSession && authSession.datasetPlatform;
    defaultProperties.dataset_created_by = authSession && authSession.datasetCreatedByClientId;

    const subscription = subscriptionsSelectors.getActiveSubscription(state);
    if (subscription) {
      let subscriber;
      if (subscription.active) {
        subscriber = 'Subscribed';
      } else {
        const dateNow = Date.now();
        const dateExpired = Date.parse(subscription.expireAt);
        if (dateExpired >= dateNow) {
          subscriber = 'Not Subscribed';
        } else {
          subscriber = 'Expired';
        }
      }
      if (subscriber) {
        defaultProperties.subscriber = subscriber;
      }

      let tierCountry;
      switch (subscription.productLineName) {
        case 'Quicken US':
          tierCountry = 'US';
          break;
        case 'Quicken CA':
          tierCountry = 'CA';
          break;
        default:
          tierCountry = null;
      }
      if (tierCountry) {
        defaultProperties.tier_country = tierCountry;
      }

      let tierName;
      switch (subscription.tierName) {
        case 'Starter':
          switch (subscription.productLineName) {
            case 'Quicken US':
              tierName = 'Starter';
              break;
            case 'Quicken CA':
              tierName = 'Starter (CA)';
              break;
            default:
              tierName = null;
          }
          break;
        case 'Deluxe':
          switch (subscription.productLineName) {
            case 'Quicken US':
              tierName = 'Deluxe';
              break;
            case 'Quicken CA':
              tierName = 'Deluxe (CA)';
              break;
            default:
              tierName = null;
          }
          break;
        case 'Premier':
          tierName = 'Premier';
          break;
        case 'Home and Business':
          tierName = 'HB (CA)';
          break;
        case 'Home, Business & Rental Property':
          tierName = 'HBR';
          break;
        default:
          tierName = null;
      }
      if (tierName) {
        defaultProperties.tier = tierName;
      }
    }

    const entitlements = entitlementsSelectors.getEntitlements(state);
    defaultProperties.entitlements = entitlements && entitlements.filter((entitlememt) => entitlememt.active).map((entitlememt) => entitlememt.id).toIndexedSeq().toArray();

    defaultProperties.pathname = window.location.pathname;

    return defaultProperties;
  }

  timer(event) {
    // eslint-disable-next-line camelcase
    window?.mixpanel?.time_event(event);
  }

  track(event, properties) {
    try {
      const defaultProperties = this.defaultProperties();
      const allProperties = { ...defaultProperties, ...properties };
      log.info(`track: ${event}\nprops: `, allProperties);
      if (allProperties.qcs_id) {
        window?.mixpanel?.identify(allProperties.qcs_id);
      }
      window?.mixpanel?.track(event, allProperties);
    } catch (e) {
      log.error(`tracking failed: ${e}`);
    }
  }

  trackActive() {
    const dateNow = new Date();
    if (dateNow - this.dateLastActiveTracked > 15 * 60 * 1000) { // once per 15 mins
      const defaultProperties = this.defaultProperties();
      if (defaultProperties.qcs_id) {
        this.track(this.events.active);
        this.dateLastActiveTracked = dateNow;
      }
    }
  }

  resetActiveTimestamp() {
    this.dateLastActiveTracked = new Date(0);
  }

}

const tracker = new Tracker();
export default tracker;

